// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3BnP6","title":"ClientCherryInfo_title__2BVrc","itemText":"ClientCherryInfo_itemText__2Rj7r"};